import { render, staticRenderFns } from "./NewOrganLink.vue?vue&type=template&id=649be4ed&"
import script from "./NewOrganLink.vue?vue&type=script&lang=ts&"
export * from "./NewOrganLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../_locales/Organs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FNewOrganLink.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/recipients/_locales/OrganReferrals.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FNewOrganLink.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/components/shared/_locales/single.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FNewOrganLink.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports